<template>
  <span class="notification-bar">
    <slot></slot>
  </span>
</template>
<script>
export default {};
</script>
